import { useMutation } from '@tanstack/react-query';

import { ProductionApi } from '../production.api';

export const useGetProductionCalculations = () => {
  return useMutation({
    mutationFn: ProductionApi.getProductionCalculations,
  });
};
